<template>
    <div
        :class="{ 'slds-has-error': isInvalid }"
        class="slds-form-element"
    >
        <label
            v-if="showLabel"
            class="slds-form-element__label"
        >
            <abbr
                v-if="isRequired"
                class="slds-required"
                :title="requiredLabel"
            >*</abbr>
            {{ decodeHtml(label) }}
            <slot name="label"></slot>
        </label>

        <div
            class="slds-form-element__control"
            style="position: relative"
        >
            <textarea
                v-if="useTextArea"
                :disabled="isDisabled"
                :value="decodeHtml(value)"
                :placeholder="placeholder"
                class="slds-textarea"
                v-on="listeners"
            ></textarea>

            <input
                v-else
                ref="input"
                :type="type"
                :disabled="isDisabled"
                :placeholder="placeholder"
                :value="decodeHtml(value)"
                class="slds-input"
                v-on="listeners"
                @blur="$emit('update:hasFocus', false)"
            >
            <slot name="extendInput"></slot>
        </div>

        <div
            v-if="isInvalid"
            class="slds-form-element__help"
        >
            <slot name="errors"></slot>
        </div>
    </div>
</template>

<script>
    import decodeHtml from '../mixins/decode-html';

    export default {
        name: 'MAInput',
        mixins: [decodeHtml],
        props: {
            value: {
                type: [String, Number],
                required: true
            },
            isRequired: {
                type: Boolean,
                default: false
            },
            useTextArea: {
                type: Boolean,
                default: false
            },
            disableResize: {
                type: Boolean,
                default: false
            },
            label: {
                type: String,
                default: ''
            },
            errors: {
                type: Array,
                default: () => []
            },
            placeholder: {
                type: String,
                default: ''
            },
            type: {
                type: String,
                default: 'text'
            },
            isInvalid: {
                type: Boolean,
                default: false
            },
            isDisabled: {
                type: Boolean,
                default: false
            },
            hasFocus: {
                type: Boolean,
                default: false
            },
            requiredLabel: {
                type: String,
                default: 'Required'
            }
        },
        computed: {
            showLabel() {
                return this.label;
            },
            hasErrors() {
                return this.errors && this.errors.length;
            },
            listeners() {
                return {
                    ...this.$listeners,
                    input: event => this.$emit('input', event.target.value)
                };
            }
        },
        watch: {
            hasFocus(value) {
                if (value) this.focus();
            }
        },
        mounted() {
            if (this.hasFocus) this.focus();
        },
        methods: {
            focus() {
                this.$refs.input.focus();
                this.$refs.input.select();
            }
        }
    };
</script>

<style lang="scss" scoped>
    .disable-resize {
        resize: none;
    }

    .slds-input {
        @media screen and (max-width: 1024px) {
            -moz-appearance: none;
            -webkit-appearance: none;
            appearance: none;
        }
    }
</style>
